import React from "react"

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer"
import archivoNarrow from "../../../assets/fonts/ArchivoNarrow-Regular.ttf"
import archivoNarrowBold from "../../../assets/fonts/ArchivoNarrow-Bold.ttf"
import commonStrings from "../../commonStrings"
import { removeHtmlTags } from "../../utilities"
import CommonConstants from "../../CommonConstants"
import uaLogo from "../../../assets/images/rsp-logo.png"
import tickCircle from "../../../assets/images/tick-circle.png"
import frameIcon from "../../../assets/images/Frame5085.png"
import pathIcon from "../../../assets/images/Path.png"

const IndicatorReportPdf = ({
  lineChartUrl,
  barChartUrl,
  indicatorTable,
  currentschoolLogo,
  selectedIndicator,
  stage,
  showInitialValueColumn,
  showPreviousRatingColumn,
  showStatusColumn,
}) => {
  Font.register({
    family: "Archivo Narrow",
    fonts: [
      {
        src: archivoNarrow,
      },
      {
        src: archivoNarrowBold,
        fontWeight: 700,
      },
    ],
  })

  const styles = StyleSheet.create({
    viewStylesTop: {
      marginTop: 60,
    },
    page: {
      fontFamily: "Archivo Narrow",
      paddingTop: 14,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },

    uaLogo: {
      width: 115,
      height: 64,
    },
    uaLogo1: {
      width: 115,
      height: 64,
    },
    imageContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 10,
    },
    heading: {
      marginTop: "5px",
      marginBottom: "5px",
      fontSize: "14px",
      fontFamily: "Archivo Narrow",
    },
    header: {
      display: "flex",
      flexDirection: "row",
      fontSize: "11",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10",
      fontWeight: "700",
      minHeight: "60",
    },
    widthHeading: {
      width: "20%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "700",
    },
    widthDescription: {
      width: "65%",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "400",
      paddingRight: "10",
      paddingLeft: "10",
    },
    widthRating: {
      width: "9%",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "700",
    },
    widthNumber: {
      width: "10%",
      alignItems: "center",
      justifyContent: "center",
    },
    stages: {
      marginTop: "10",
      border: "2px solid red",
      padding: "3px",
      width: "15%",
      fontSize: "11",
      textAlign: "center",
      fontWeight: "600",
      textTransform: "uppercase",
    },
    description: {
      fontSize: "11",
      marginTop: "10",
    },
    need: {
      width: "50%",
      textAlign: "center",
    },
    strength: {
      width: "50%",
      textAlign: "center",
    },
    dFlex: {
      marginTop: "10px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
    },
    pointsAreaOfStrength: {
      width: "50%",
    },
    TextAreaOfStrenght: {
      paddingLeft: "5px",
      paddingRight: "10px",
      fontSize: "10px",
      marginTop: "5px",
      marginBottom: "6px",
    },
    pointsAreaOfNeed: { width: "50%" },
    TextAreaOfNeed: {
      paddingLeft: "5px",
      paddingRight: "10px",
      fontSize: "10px",
      marginTop: "6px",
      marginBottom: "5px",
    },
    mergeViews: {
      display: "flex",
      flexDirection: "row",
    },
    paddingX: {
      paddingLeft: "7px",
      paddingRight: "7px",
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "#ccc",
      paddingVertical: 4,
    },
    tableCellNumber: {
      width: "8%",
      fontSize: 8,
      paddingHorizontal: 2,
    },
    tableCellIndicator: {
      width: "27%",
      fontSize: 8,
      paddingHorizontal: 4,
    },
    tableCell: {
      width: "11.5%",
      fontSize: 8,
      paddingHorizontal: 2,
      textAlign: "center",
    },
    completedContainer: {
      flexDirection: "row",
      alignItems: "center",
      marginTop: 5,
    },
    completedText: {
      marginRight: 8,
    },
    tickIcon: {
      width: 8,
      height: 8,
    },
    section1: {
      display: "flex",
      justifyContent: "flex-start",
      alignContent: "flex-start",
      width: "100%",
      fontSize: "14px",
      marginLeft: "15px",
      fontWeight: "800",
    },
    section2: {
      display: "flex",
      justifyContent: "flex-start",
      alignContent: "flex-start",
      width: "100%",
      fontSize: "14px",
      marginBottom: "10px",
      marginLeft: "17px",
      fontWeight: "800",
    },
    section3: {
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      fontSize: "16px",
      fontWeight: "800",
      marginTop: "10px",
    },
    barChartUrls: {
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      width: 510,
      height: 280,
    },
    lineChartUrls: {
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      width: 530,
      height: 300,
    },
  })

  return (
    <Document pageCount={4}>
      {/* First Page with Bar Chart */}
      {barChartUrl && (
        <Page size="A4" style={styles.page}>
          <View style={styles.imageContainer} fixed>
            <Image style={styles.uaLogo} src={uaLogo} />

            {currentschoolLogo && (
              <Image style={styles.uaLogo1} src={currentschoolLogo} />
            )}
          </View>
          <View style={styles.section3}>
            <Text>Indicator Progress Report</Text>
          </View>
          <View style={styles.section}>
            <View style={styles.viewStylesTop}>
              <View style={styles.section2}>
                <Text>{(stage && stage.label) || "Unknown Stage"}</Text>
              </View>

              <Image
                style={styles.barChartUrls}
                src={barChartUrl}
                alt="Bar chart showing performance trend"
              />
            </View>
          </View>
        </Page>
      )}

      {/* Second Page with Line Chart */}
      {lineChartUrl && (
        <Page size="A4" style={styles.page}>
          <View style={styles.imageContainer} fixed>
            <Image style={styles.uaLogo} src={uaLogo} />

            {currentschoolLogo && (
              <Image style={styles.uaLogo1} src={currentschoolLogo} />
            )}
          </View>

          <View style={styles.section}>
            <View style={styles.viewStylesTop}>
              <View style={styles.section1}>
                <Text>Indicator {selectedIndicator} </Text>
              </View>
              <Image
                style={styles.lineChartUrls}
                src={lineChartUrl}
                alt="Line chart showing performance trend"
              />
            </View>
          </View>
        </Page>
      )}
      <Page size="A4" style={styles.page}>
        <View style={styles.imageContainer} fixed>
          <Image style={styles.uaLogo} src={uaLogo} />
          {currentschoolLogo && (
            <Image style={styles.uaLogo1} src={currentschoolLogo} />
          )}
        </View>
        <View>
          {" "}
          <Text style={{ fontSize: 14, fontWeight: "bold" }}>
            {commonStrings.indicatorTableTitle || "Indicator Table"}
          </Text>
        </View>

        {/* <View
          style={[styles.tableRow, { backgroundColor: "#eee", marginTop: 10 }]}
        >
          <Text style={styles.tableCellNumber}>
            {CommonConstants.columnTitles.indicatorNumber}
          </Text>
          <Text style={styles.tableCellIndicator}>
            {CommonConstants.columnTitles.indicator}
          </Text>
          <Text style={styles.tableCell}>
            {CommonConstants.columnTitles.initialValue}
          </Text>
          <Text style={styles.tableCell}>
            {CommonConstants.columnTitles.previousRating}
          </Text>
          <Text style={styles.tableCell}>
            {CommonConstants.columnTitles.currentValue}
          </Text>

          <Text style={styles.tableCell}>
            {CommonConstants.columnTitles.status}
          </Text>
        </View> */}
        <View
          style={[styles.tableRow, { backgroundColor: "#eee", marginTop: 10 }]}
        >
          <Text style={styles.tableCellNumber}>
            {CommonConstants.columnTitles.indicatorNumber}
          </Text>
          <Text style={styles.tableCellIndicator}>
            {CommonConstants.columnTitles.indicator}
          </Text>

          {showInitialValueColumn && (
            <Text style={styles.tableCell}>
              {CommonConstants.columnTitles.initialValue}
            </Text>
          )}

          {showPreviousRatingColumn && (
            <Text style={styles.tableCell}>
              {CommonConstants.columnTitles.previousRating}
            </Text>
          )}

          <Text style={styles.tableCell}>
            {CommonConstants.columnTitles.currentValue}
          </Text>

          {showStatusColumn && (
            <Text style={styles.tableCell}>
              {CommonConstants.columnTitles.status}
            </Text>
          )}
        </View>

        {indicatorTable.map((row, index) => (
          <View
            key={index}
            style={[
              styles.tableRow,
              index % 2 === 0 ? { backgroundColor: "#f9f9f9" } : {},
            ]}
          >
            <Text style={styles.tableCellNumber}>{row.index || "N/A"}</Text>
            <Text style={styles.tableCellIndicator}>
              {removeHtmlTags(row.indicator)}
            </Text>

            {showInitialValueColumn && (
              <Text style={styles.tableCell}>
                {row.initial_value != null ? row.initial_value : "N/A"}
              </Text>
            )}

            {showPreviousRatingColumn && (
              <Text style={styles.tableCell}>
                {row.previous_rating != null ? row.previous_rating : "N/A"}
              </Text>
            )}

            <Text style={styles.tableCell}>
              {row.current_value != null ? row.current_value : "N/A"}
            </Text>

            {showStatusColumn && (
              <Text style={styles.tableCell}>
                {row.goal !== null && row.current_value === row.goal ? (
                  <Image src={tickCircle} alt="Completed" />
                ) : row.previous_rating !== null
                  && row.previous_rating > row.current_value ? (
                    <Image src={frameIcon} alt="Upwards" />
                  ) : row.previous_rating !== null
                  && row.previous_rating < row.current_value ? (
                    <Image src={pathIcon} alt="Declined" />
                    ) : (
                      "N/A"
                    )}
              </Text>
            )}
          </View>
        ))}
      </Page>
    </Document>
  )
}
export default IndicatorReportPdf
